<div class="close-div">
  <img src="../../../../assets/icon/close-icon.svg" alt="" class="close-icon" (click)="closeUnpauseSyndicateDialog()" />
</div>
<div class="main-div">
  <img src="../../../../assets/images/leavebg-circle.png" alt="" class="bg-circle" />
  <div class="cel-div">
    <h1 class="celebration">😏</h1>
  </div>
  <div class="title-div">
    <p class="unpause-title">
      It will be great to have <br />you back. You can start<br />
      playing straight away.
    </p>
  </div>
  <div class="subtitle-div">
    <p class="unpause-subtitle">Being in a syndicate means...</p>
  </div>
  <div class="content-div">
    <p class="subtitle-1"><span class="bullet">&bull;</span><span> Automatic</span> entry into every draw</p>
    <p class="subtitle-2"><span class="bullet">&bull;</span><span> One-off</span> lottery purchases</p>
    <p class="subtitle-3"><span class="bullet">&bull;</span>Get <span>more lines</span> for less!</p>
  </div>
  <div class="unpause-div">
    <ion-button class="unpause-btn" (click)="startSpinner(); unPauseSyndicate()">
      @if (!spinnerAnimation && proceed) {
        <span>Unpause</span>
      }
      @if (spinnerAnimation) {
        <div class="spinners">
          <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
          </mat-progress-spinner>
        </div>
      }
      @if (!proceed) {
        <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
      }
    </ion-button>
  </div>
</div>
